// Builds an internal, CallMe📲Gerard.com-branded wrapper URL for any external destination.
// All outbound partner links route through /go so they appear on a branded page in unison with the site.
export function partnerHref(url, name = "") {
  return `/go?name=${encodeURIComponent(name)}&url=${encodeURIComponent(url)}`;
}
